module.exports = __webpack_public_path__ + "img/01841_06.5ad711e8.png";